import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import responseNotification from './lib/responseNotification.js'

import {
  getPlans,
  me,
  config,
  cancelAccount,
  login, logout,
  updatePreferences, getPreferences,
  inviteUser,
  addUserToAccount,
  verifySignUp,
  getUpdateRuleFields, updateUpdateRule, createUpdateRule, getUpdateRule,
  getUpdateFields, createUpdate, getScheduled, loadUpdateRuleLimited,
  createReferral, confirmReferral
} from './lib/api/calls'

import accounts from './store/accounts'
import advertisements from './store/advertisements'
import categories from './store/categories'
import formats from './store/formats'
import users from './store/users'
import coupons from './store/coupons'
import updates from './store/updates'

const store = new Vuex.Store({
  modules: {
    accounts,
    advertisements,
    categories,
    formats,
    users,
    coupons,
    updates
  },
  state: {
    loadOptions: {},
    me: {},
    plans: [],
    account: {},
    planChosen: false,
    adminMocking: null,
    preferences: {},
    updateable_fields: [],
    updateable_settings: {},
    update_fields: [],
    temp_update_fields: [],
    scheduled: [],
    limited_update_rule: {}
  },
  getters: {
    isFormatAdmin (state) {
      return state.me.admin || state.me.format_admin
    }
  },
  mutations: {
    setPlans (state, plans) {
      state.plans = plans;
    },
    setMe(state, me){
      state.me = me;
    },
    setConfig(state, config){
      state.config = config;
    },
    choosePlan(state, plan){
      state.account.plan = plan;
      state.planChosen = plan;
    },
    setAccount(state, value) {
      localStorage.account_id = value.id;
      if (value.plan) state.planChosen = value.plan;
      state.account = value;
    },
    setAdminDeMocker(state) {
      state.adminMocking = localStorage.user_id && localStorage.user_id > 0;
    },
    setPreferences(state, value) {
      if (value.length) {
        value.forEach(val => {
          state.preferences[val.name] = val.value
        })
      }
    },
    setUpdateRuleFields(state, value) {
      state.temp_update_fields = value;
    },
    setUpdateRuleSettings(state, value) {
      state.temp_update_fields.forEach((field) => {
        state.updateable_settings[field.name] = value[field.name];
      });
      state.updateable_fields = state.temp_update_fields;
    },
    setUpdateFields(state, value) {
      state.update_fields = value;
    },
    setScheduled(state, value) {
      state.scheduled = value;
    },
    setUpdateRuleLimited(state, value) {
      state.limited_update_rule = value;
    }
  },
  actions: {
    loadScheduled({commit}, id) {
      return getScheduled(id).then(times => commit('setScheduled', times))
    },
    loadUpdateRuleFields({commit}) {
      return getUpdateRuleFields().then(fields => {
        commit('setUpdateRuleFields', fields)
        return fields;
      });
    },
    loadUpdateRuleLimited({commit}, id) {
      return loadUpdateRuleLimited(id).then(update_rule => commit('setUpdateRuleLimited', update_rule))
    },
    createReferral(context, {email}) {
      createReferral(email).then((response) => {
        if (response.errors) {
          responseNotification(context, { error: response.errors }, {})
        } else {
          responseNotification(context, {}, 'Successfully Sent Referral')
        }
      })
    },
    confirmReferral (context, {token}) {
      confirmReferral(token)
    },
    createUpdate(context, {data, cb}) {
      createUpdate(data).then((response) => {
        if (response.errors) {
          responseNotification(context, { error: response.errors }, {})
        }
        if (cb) cb(response);
      })
    },
    loadUpdateFields({commit}) {
      getUpdateFields().then(fields => commit('setUpdateFields', fields))
    },
    updateUpdateRule (context, {id, payload}) {
      updateUpdateRule(id, payload);
    },
    async createUpdateRule ({commit}, payload) {
      let rtnVal;
      await createUpdateRule(payload).then((id) => {
        rtnVal = id
      });
      return rtnVal;
    },
    getUpdateRule ({commit}, id) {
      return getUpdateRule(id).then(response => {
        commit('setUpdateRuleSettings', response)
        return response
      })
    },
    setAccount({dispatch, commit}, account) {
      commit('setAccount', account);
      dispatch('advertisements/load');
      dispatch('formats/load');
    },
    reloadMe({dispatch, commit}) {
      dispatch('loadMe')
        .then(() => dispatch('accounts/loadOwned'))
        .then(() => dispatch('advertisements/load'))
        .then(() => dispatch('loadAdminDeMocker'));
    },
    loadAdminDeMocker({commit}) {
      commit('setAdminDeMocker');
    },
    loadMe({commit}){
      return me().then(me => {
        commit('setMe', me);
        return me;
      });
    },
    loadConfig({commit}){
      return config().then(config => {
        commit('setConfig', config);
        return config;
      });
    },
    loadPreferences({commit}) {
      getPreferences().then(userPreferences => commit('setPreferences', userPreferences));
    },
    loadPlans({commit}){
      getPlans().then(plans => commit('setPlans', plans));
    },
    cancelAccount(context){
      cancelAccount().then(logout).catch((result)=>{
        responseNotification(store, {error: 'Something went wrong!'});
      });
    },
    login(context, payload){
      let { email, password } = payload;

      login(email, password).then((result)=>{
        if(!result.error){
          location.reload();
        } else {
          responseNotification(context, result);
          context.dispatch('setAccount', 0)
        }
      }).catch((e)=>{
        console.log('e', e);
        responseNotification(context, {error: 'Login failure!'});
      });
    },
    updatePreferences(context, {userId, payload}){
      updatePreferences(userId, payload).then(()=> {
        context.dispatch('loadMe');
        context.dispatch('loadPreferences');
      });
    },
    inviteUser(context, userEmail) {
      inviteUser(userEmail).then((response) => {
        responseNotification(context, response, 'User Invited!');
        context.dispatch('accounts/loadOwned');
      });
    },
    addUserToAccount(context, {token}) {
      addUserToAccount(token).then((response) => {
        responseNotification(context, response, 'You joined an account!')
        delete localStorage.account_token;
        context.dispatch('accounts/loadOwned').then((account) => {
          let account_found = this.getters['accounts/owned'].find(acct => acct.id == response.account_id);
          if (account_found) {
            context.dispatch('setAccount', account_found);
          }
        });
      })
    },
    verifySignUp(context, {token}) {
      verifySignUp(token).then((response) => {
        if(!response.error){
          delete localStorage.signup_token;
          responseNotification(context, response, 'Email Confirmed Successfully!');
          if (!this.state.me.id) {
            location.reload();
          }
        } else {
          responseNotification(context, response);
        }
      })
    }
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store.js